// NOTE (2026-04-22): API_URL resolution is now derived from window.location
// with an env-var override. Previously this file hardcoded
// `https://python.backend.aiinterviewagents.com` as the fallback, which
// disagreed with frontend/components/voice-room/lib/config.ts (derives from
// window.location.origin). The two divergent fallbacks meant the voice room
// and the recruiter portal could end up talking to different backends in
// any environment where NEXT_PUBLIC_API_URL wasn't set at build time.
// Both files now share the same resolution logic via lib/config-base.

const stripWrappingQuotes = (value) => {
    if (typeof value !== "string") return "";
    const trimmed = value.trim();
    if (
        (trimmed.startsWith("\"") && trimmed.endsWith("\"")) ||
        (trimmed.startsWith("'") && trimmed.endsWith("'"))
    ) {
        return trimmed.slice(1, -1).trim();
    }
    return trimmed;
};

const trimTrailing = (value) => value.replace(/\/+$/, "");

const getBrowserOrigin = () => {
    if (typeof window !== "undefined" && window.location) {
        return window.location.origin;
    }
    return "";
};

const resolveBaseUrl = (envValue, fallback) => {
    const normalized = stripWrappingQuotes(envValue || "");
    if (normalized) return trimTrailing(normalized);
    return trimTrailing(fallback);
};

const envBool = (value, fallback = false) => {
    const normalized = stripWrappingQuotes(value || "").toLowerCase();
    if (!normalized) return fallback;
    return ["1", "true", "yes", "on"].includes(normalized);
};

// Prefer the NEXT_PUBLIC_API_URL env (baked in at build time on prod).
// Fall back to the browser's own origin, which matches the voice-room
// config and lets the same build run on aiia-test / sandbox / prod with
// no recompilation. Empty string on SSR is acceptable — all callers of
// API_URL are client-side (useEffect / event handlers / fetchWithAuth).
export const API_URL = resolveBaseUrl(
    process.env.NEXT_PUBLIC_API_URL,
    getBrowserOrigin()
);
// Java API is now served by the Django monorepo backend.
// Kept as alias so 43+ files importing JAVA_API_URL keep working.
// PR-6 (legacy cleanup) will grep-replace JAVA_API_URL → API_URL and
// delete this alias.
export const JAVA_API_URL = API_URL;

export const REPORT_DETAIL_USE_PYTHON = envBool(
    process.env.NEXT_PUBLIC_REPORT_DETAIL_USE_PYTHON,
    true
);
export const ENABLE_ROLES_CMS = envBool(
    process.env.NEXT_PUBLIC_ENABLE_ROLES_CMS,
    true
);
export const TWITTER_LINK = "https://x.com/AinterviewAgent"
export const INSTAGRAM_LINK = "https://www.instagram.com/aiinterviewagents_com?igsh=cmFscGZzODU2Zzhy"
export const LINKEDIN_LINK = "https://www.linkedin.com/company/ai-interview-agent/"

export const companies = [
    { name: "Hitachi", logo: "/companies/hitachi.svg" },
    { name: "KPMG", logo: "/companies/kpmg.svg" },
    { name: "Lantronix", logo: "/companies/lantronix.svg" },
    { name: "Moxa", logo: "/companies/moxa.svg" },
    { name: "Microsoft", logo: "/companies/ms.svg" },
    { name: "NBC", logo: "/companies/nbc.svg" },
    { name: "NTT", logo: "/companies/ntt.svg" },
    { name: "Omnibiz", logo: "/companies/omnibiz.svg" },
    { name: "Yamaha", logo: "/companies/yamaha.svg" }
];

export const universities = [
    { name: "Dehradun Institute of Technology - Igniters Club", logo: "/clg-logos/DIT.png" },
    { name: "FMS : MarkSoc", logo: "/clg-logos/fms.png" },
    { name: "IIT Guwahati : E cell", logo: "/clg-logos/IITG.png" },
    { name: "IIT Hyderabad : Elan & nVision", logo: "/clg-logos/iithyderabad.png" },
    { name: "IIT Kanpur : E Cell", logo: "/clg-logos/iitkanpur.png" },
    { name: "IIT KGP : Share", logo: "/clg-logos/iit-kharagpur.png" },
    { name: "ISB & M : Grey Cell", logo: "/clg-logos/isb&m.png" },
    { name: "LBISM : Management Grid", logo: "/clg-logos/lbsim.png" },
    { name: "MAIMS : ARTHONOMICS", logo: "/clg-logos/maims.png" },
    { name: "MDI Gurgaon", logo: "/clg-logos/mdi.png" },
    { name: "NIE Mysore : Anveshan", logo: "/clg-logos/nie.png" },
    { name: "SRM University : Genesis", logo: "/clg-logos/SRM.png" },
    { name: "IIETE Navi Mumbai : RAIT CTF", logo: "/clg-logos/theinstitutionofete.png" },
    { name: "IIIT Nagpur : E Cell", logo: "/clg-logos/xyz.png" },

    { logo: '/clg-logos/1.png', name: 'LPU', club: 'Chanakya' },
    { logo: '/clg-logos/2.png', name: 'MAIT', club: 'IEEE' },
    { logo: '/clg-logos/3.png', name: 'IISc Bangalore', club: 'Pravega' },
    { logo: '/clg-logos/4.png', name: 'MNNIT Allahabad', club: 'E-Cell' },
    { logo: '/clg-logos/5.png', name: 'IIT Kharagpur', club: "NSSC'25" },
    { logo: '/clg-logos/6.png', name: 'Hacker Unity', club: '' },
    { logo: '/clg-logos/7.png', name: 'IIM Udaipur', club: 'ConsultU' },
    { logo: '/clg-logos/8.png', name: 'Jadavpur University', club: 'Finance and Consulting Club' },
    { logo: '/clg-logos/9.png', name: 'XLRI Jamshedpur', club: 'Ensemble - Valhalla' },
    { logo: '/clg-logos/10.png', name: 'NSUT', club: 'ASME' },
    { logo: '/clg-logos/11.png', name: 'Hansraj College, DU', club: 'S.P.A.R.C.' },
    { logo: '/clg-logos/12.png', name: 'KMC, DU', club: 'The Commerce Society' },
];
